module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="matchup-users-data">\n\n	';
 if (home.id) { 
__p+='\n	<div class="matchup-users-home">\n		<figure class="avatar">\n			<img src="'+
((__t=( home.avatar_url ))==null?'':_.escape(__t))+
'" alt="">\n		</figure>\n		<div class="text">\n			<div class="team-name">'+
((__t=( home.name ))==null?'':_.escape(__t))+
'</div>\n			<div class="user-name">\n				'+
((__t=( home.firstname))==null?'':_.escape(__t))+
' <span class="hidden-mobile">'+
((__t=( home.lastname ))==null?'':_.escape(__t))+
'</span>\n			</div>\n			<div class="ladder-pos">\n				Ladder <span class="hidden-mobile">Position</span>: <strong>'+
((__t=( _.ordinalSuffixOf(home.ladder_position) ))==null?'':_.escape(__t))+
'</strong>\n			</div>\n		</div>\n		<div class="score '+
((__t=( home.is_playing_now ? 'active' : '' ))==null?'':_.escape(__t))+
'">\n			<p>\n				'+
((__t=( home.score ))==null?'':_.escape(__t))+
'\n			</p>\n\n			';
 if (home.proj_score) { 
__p+='\n			<p class="projected">\n				'+
((__t=( home.proj_score ))==null?'':_.escape(__t))+
'\n			</p>\n			';
 } 
__p+='\n\n		</div>\n	</div>\n	';
 } else { 
__p+='\n		<div class="matchup-users-data-empty">No Opponent</div>\n	';
 } 
__p+='\n\n	<div class="vs">Vs</div>\n\n\n	';
 if (away.id) { 
__p+='\n	<div class="matchup-users-away">\n		<div class="score '+
((__t=( away.is_playing_now ? 'active' : '' ))==null?'':_.escape(__t))+
'">\n			<p>\n				'+
((__t=( away.score ))==null?'':_.escape(__t))+
'\n			</p>\n\n			';
 if (away.proj_score) { 
__p+='\n			<p class="projected">\n				'+
((__t=( away.proj_score ))==null?'':_.escape(__t))+
'\n			</p>\n			';
 } 
__p+='\n		</div>\n		<div class="text">\n			<div class="team-name">'+
((__t=( away.name ))==null?'':_.escape(__t))+
'</div>\n			<div class="user-name">\n				'+
((__t=( away.firstname))==null?'':_.escape(__t))+
' <span class="hidden-mobile">'+
((__t=( away.lastname ))==null?'':_.escape(__t))+
'</span>\n			</div>\n			<div class="ladder-pos">\n				Ladder <span class="hidden-mobile">Position</span>: <strong>'+
((__t=( _.ordinalSuffixOf(away.ladder_position) ))==null?'':_.escape(__t))+
'</strong>\n			</div>\n		</div>\n		<figure class="avatar">\n			<img src="'+
((__t=( away.avatar_url ))==null?'':_.escape(__t))+
'" alt="">\n		</figure>\n	</div>\n	';
 } else { 
__p+='\n	<div class="matchup-users-data-empty">No Opponent</div>\n	';
 } 
__p+='\n\n</div>\n\n<div class="matchup-users-numbers">\n\n	';
 if (home.id) { 
__p+='\n	<div class="matchup-users-home">\n\n		<div class="item first">\n			<div class="label">MINS REMAINING</div>\n			<div class="number">\n				';
 if (home.remain_mins) { 
__p+='\n					'+
((__t=( home.remain_mins ))==null?'':_.escape(__t))+
'/'+
((__t=( home.total_mins ))==null?'':_.escape(__t))+
'\n				';
 } else { 
__p+='\n					0/'+
((__t=( home.total_mins ))==null?'':_.escape(__t))+
'\n				';
 } 
__p+='\n			</div>\n		</div>\n		<div class="item">\n			<div class="label">YTP</div>\n			<div class="number">\n				'+
((__t=( home.ytp ))==null?'':_.escape(__t))+
'\n			</div>\n		</div>\n		<div class="item">\n			<div class="label">LIVE</div>\n			<div class="number">\n				'+
((__t=( home.live ))==null?'':_.escape(__t))+
'\n			</div>\n		</div>\n		<div class="item">\n			<div class="label">FINAL</div>\n			<div class="number">\n				'+
((__t=( home.final ))==null?'':_.escape(__t))+
'\n			</div>\n		</div>\n\n	</div>\n	';
 } else { 
__p+='\n	<div class="matchup-users-data-empty"></div>\n	';
 } 
__p+='\n\n	';
 if (away.id) { 
__p+='\n	<div class="matchup-users-away">\n		<div class="item first">\n			<div class="label">MINS REMAINING</div>\n			<div class="number">\n				';
 if (away.remain_mins) { 
__p+='\n					'+
((__t=( away.remain_mins ))==null?'':_.escape(__t))+
'/'+
((__t=( away.total_mins ))==null?'':_.escape(__t))+
'\n				';
 } else { 
__p+='\n					0/'+
((__t=( away.total_mins ))==null?'':_.escape(__t))+
'\n				';
 } 
__p+='\n			</div>\n		</div>\n		<div class="item">\n			<div class="label">YTP</div>\n			<div class="number">\n				'+
((__t=( away.ytp ))==null?'':_.escape(__t))+
'\n			</div>\n		</div>\n		<div class="item">\n			<div class="label">LIVE</div>\n			<div class="number">\n				'+
((__t=( away.live ))==null?'':_.escape(__t))+
'\n			</div>\n		</div>\n		<div class="item">\n			<div class="label">FINAL</div>\n			<div class="number">\n				'+
((__t=( away.final ))==null?'':_.escape(__t))+
'\n			</div>\n		</div>\n	</div>\n	';
 } else { 
__p+='\n	<div class="matchup-users-data-empty"></div>\n	';
 } 
__p+='\n\n</div>';
}
return __p;
};
